import type React from 'react';
import CalendarSettingsPage from './CalendarSettingsPage';

const CalendarSettingsRoute: React.FC = () => <CalendarSettingsPage />;

export default CalendarSettingsRoute;
